export default __webpack_public_path__ + "static/media/GB.c649a42b.svg";